import {BaseApi, RequireAuthApi} from '@/api/base.api';
import {TimelineInteractionModel} from '@/models/timeline.model';

export class TimelineInteractionApi extends BaseApi<TimelineInteractionModel> {

  constructor(protected challengeId: number, protected timelineId: number) {
    super(`challenges/${challengeId}/timelines/${timelineId}/interactions`, [
      RequireAuthApi.ALL,
      RequireAuthApi.CREATE,
      RequireAuthApi.UPDATE,
      RequireAuthApi.DESTROY,
    ]);
  }
}
